

import * as React from "react";
import { IActiveOrders } from "../../../interfaces/IOrder";
import OrderItem from "./OrderItem";
import {Api} from "../../../lib/Api";

interface IModifyHourProps {
    order: any
    closed: Function
}


interface IModifyHourState {
    hours: number
}

export default class ModifyHour extends React.Component<IModifyHourProps, IModifyHourState>{

    constructor(props:IModifyHourProps){
        super(props);
        this.state = {
            hours: this.props.order.hours
        }
    }

    private modifyHour(){
        let saveData = {
            orderId: this.props.order.id,
            hours: this.state.hours

        };
        Api.call('/restaurants/order/modifyHours', saveData, (result)=>{
           setTimeout(() => {
                this.props.closed(result.order);
            }, 800);
        });
    }

    private priceModifier(type){
        let hours = this.state.hours;
        this.setState({
            hours: type == 'increase' ? hours += 1 : hours-=1
        })
    }


    render() {
        let order = this.props.order;
        return (
            <div className="modal_content edit-offer-box edit-order-box">

                    <div className="form-row">
                        <div className="col text-center">
                            <img src = {order.offer.offerType.img}/>
                            <h1>
                                { order.offer.offerType.name}
                            </h1>
                        </div>
                    </div>
                    <div className="form-row label_row">
                        <div className="col text-center">
                            hour:
                        </div>
                    </div>
                    <div className="form-row modifier_row">
                        <div className="col text-right">
                            <a className="btn price_minus_btn" onClick={ (e) => { this.priceModifier('decrease') } }>
                                -
                            </a>
                        </div>
                        <div className="col-5 price-field">
                            {this.state.hours}
                        </div>
                        <div className="col text-left">
                            <a className="btn price_plus_btn" onClick={ (e) => { this.priceModifier('increase') } }>
                                +
                            </a>
                        </div>
                    </div>

                    <button className="green_btn submit_btn" onClick={ e => this.modifyHour() }>Send new offer</button>

                <button className = "purple_btn" onClick={() => this.props.closed()}>Cancel</button>
            </div>
        );
    }
}
